import React from 'react';
import clsx from 'clsx';
import { DataCard, Loading } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import styles from './DisplayContent.css';

type Props = {
    overrideStatus: string;
    overrideStatusBoolean: boolean;
    merchantSpecificSetting?: string;
    // needed for when we do deploy version
    isLoading: boolean;
};

const DisplayContent = ({ overrideStatus, overrideStatusBoolean, merchantSpecificSetting, isLoading }: Props) => {
    const { t } = useTranslation();
    if (isLoading)
        return (
            <div data-testid='loading'>
                <Loading size='sm' fillName='orange' />
            </div>
        );
    return (
        <div className={styles.displayContentContainer} data-testid='display-content'>
            <div className={clsx(styles.addEditInfo, !overrideStatusBoolean && styles.inactive)}>
                <DataCard
                    label={t('Status')}
                    data={
                        <span className={styles.ruleStatus}>
                            {t('For this Merchant, this rule is')} <span>{t(overrideStatus)}</span>
                        </span>
                    }
                />
                <DataCard
                    dataBoldFont={false}
                    label={t('Rule Settings')}
                    data={merchantSpecificSetting}
                    className={styles.ruleSetting}
                />
            </div>
        </div>
    );
};

export default DisplayContent;
